import { Box } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers-pro';

import type { PlanningData } from './planningData.types.ts';

import { LeistungIndexTags } from '../../../components/general/ThemaHeader/LeistungIndexTags.tsx';
import { GetBookableExpertenByThemaOutput, ModulFromThemaRouter } from '../../../dtos.ts';
import { getLeistungstemplatesFromModul } from '../../../utils/getLeistungstemplatesFromModul.ts';
import { content } from '../CreateDurchgang.content.ts';
import { SaveButtonState } from '../DurchgangPlanung.types.ts';
import { CreateDurchgangDayInputs } from './CreateDurchgangDayInputs.tsx';
import { getDauerDays } from './CreateDurchgangInput.utils.ts';

type CreateDurchgangModulProps = Readonly<{
  modul: Pick<ModulFromThemaRouter, 'modulnummer' | 'dauer' | 'teilleistungstemplates'>;
  modulIndex: number;
  planningData: PlanningData;
  resetDurchgangAvailability: () => void;
  setPlanningData: React.Dispatch<React.SetStateAction<PlanningData>>;
  setSaveButtonState: React.Dispatch<React.SetStateAction<SaveButtonState>>;
  expertePool: GetBookableExpertenByThemaOutput | undefined;
  useExpertenForAllDays: boolean;
  setUseExpertenForAllDays: React.Dispatch<React.SetStateAction<boolean>>;
  referenceDate: Date | null;
}>;

export const CreateDurchgangModul = ({
  modul,
  modulIndex,
  planningData,
  resetDurchgangAvailability,
  setPlanningData,
  expertePool,
  useExpertenForAllDays,
  setUseExpertenForAllDays,
  referenceDate,
}: CreateDurchgangModulProps) => (
  <>
    <Box display="grid" gridTemplateColumns="28px repeat(3, minmax(0,1fr))" gap={2} mb={1} alignItems="center">
      <Box
        width={28}
        height={28}
        display="flex"
        justifyContent="center"
        alignItems="center"
        bgcolor="surface.brand"
        borderRadius={999}
        color="text.primaryOnBrand"
      >
        {modul.modulnummer}
      </Box>
      <DatePicker
        label={content.date}
        referenceDate={referenceDate ?? undefined}
        sx={{
          width: '100%',
          maxWidth: '360px',
          '& > div': {
            height: '36px',
            borderRadius: '8px !important',
            '& > fieldset': {
              borderColor: 'rgba(0, 0, 0, 0.54) !important',
            },
          },
        }}
        onChange={(newValue) => {
          const moduleData = [...planningData.module];
          moduleData[modulIndex].datum = newValue ?? null;
          setPlanningData((prev) => ({ ...prev, module: moduleData }));
          resetDurchgangAvailability();
        }}
        value={planningData.module[modulIndex].datum}
        openTo="day"
        views={['year', 'month', 'day']}
      />
      <div className="ml-auto -col-1">
        <LeistungIndexTags leistungstemplates={getLeistungstemplatesFromModul(modul)} />
      </div>
    </Box>
    {Array.from(new Array(getDauerDays(modul.dauer)).keys()).map((_, dayIndex) => (
      <CreateDurchgangDayInputs
        key={`modul${modul.modulnummer}tag${dayIndex + 1}`}
        modulIndex={modulIndex}
        dayIndex={dayIndex}
        planningData={planningData}
        resetDurchgangAvailability={resetDurchgangAvailability}
        setPlanningData={setPlanningData}
        expertePool={expertePool}
        useExpertenForAllDays={useExpertenForAllDays}
        setUseExpertenForAllDays={setUseExpertenForAllDays}
      />
    ))}
  </>
);
